import { useCreateDraftWithdrawal } from './useCreateDraftWithdrawal'
import { useMemo, useState } from 'react'
import { useSubmitWithdrawal } from './useSubmitWithdrawal'
import { useUpdateDraftWithdrawal } from './useUpdateDraftWithdrawal'
import { withdrawalSteps, withdrawalDraftDefaultData } from '../../cryptoPaymentConstants'

export const useWithdrawalFormAPI = ({ loading, setLoading, isXRPCryptoType }) => {
  const [withdrawalStep, setWithdrawalStep] = useState(withdrawalSteps.create)
  const [withdrawalDraftData, setWithdrawalDraftData] = useState(withdrawalDraftDefaultData)
  const [withdrawalFormError, setWithdrawalFormError] = useState('')

  const { onWithdrawalDraftCreate } = useCreateDraftWithdrawal({
    loading,
    setLoading,
    isXRPCryptoType,
    setWithdrawalStep,
    setWithdrawalFormError,
    setWithdrawalDraftData
  })

  const { onWithdrawalFormSubmit, withdrawalResponseData, resetWithdrawalResponseData } = useSubmitWithdrawal({
    loading,
    setLoading,
    setWithdrawalFormError,
    uuid: withdrawalDraftData.uuid
  })

  const { updateDraftWithdrawal } = useUpdateDraftWithdrawal({
    loading,
    setLoading,
    isXRPCryptoType,
    setWithdrawalFormError,
    setWithdrawalDraftData,
    uuid: withdrawalDraftData.uuid
  })

  const handleSubmit = useMemo(() => {
    return {
      [withdrawalSteps.create]: onWithdrawalDraftCreate,
      [withdrawalSteps.submit]: onWithdrawalFormSubmit
    }
  }, [onWithdrawalDraftCreate, onWithdrawalFormSubmit])

  return {
    withdrawalStep,
    setWithdrawalStep,
    withdrawalDraftData,
    withdrawalFormError,
    updateDraftWithdrawal,
    withdrawalResponseData,
    setWithdrawalDraftData,
    setWithdrawalFormError,
    resetWithdrawalResponseData,
    handleSubmit: handleSubmit[withdrawalStep]
  }
}
